
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.88 9.71l-2.85-2.85a.41.41 0 00-.581 0l-.774.773a.41.41 0 000 .581l.828.828h-2.877V3.814a.41.41 0 00-.41-.41H12.12a.41.41 0 00-.41.41v12.372c0 .226.183.41.41.41h1.095a.41.41 0 00.41-.41v-5.228h2.877l-.828.828a.41.41 0 000 .58l.774.775a.41.41 0 00.58 0l2.85-2.85a.41.41 0 000-.581zM7.879 3.405H6.784a.41.41 0 00-.41.41v5.228H3.497l.828-.828a.41.41 0 000-.58l-.774-.775a.41.41 0 00-.58 0L.12 9.71a.41.41 0 000 .581l2.85 2.85a.41.41 0 00.58 0l.774-.774a.41.41 0 000-.58l-.828-.828h2.877v5.227c0 .227.183.41.41.41H7.88a.41.41 0 00.41-.41V3.816a.41.41 0 00-.41-.411z"}})])
          )
        }
      }
    